<template>
  <div name="mainpopup">
    <div
      class="wrapper"
      v-if="view"
      @mouseenter="pauseAutoPlay"
      @mouseleave="resumeAutoPlay"
    >
      <!-- 롤링팝업 (2개 이상일 때) -->
      <div class="popup-body" v-if="tabButtons.length > 1">
        <div class="slide-container">
          <div
            class="slide-item"
            :style="{
              width: `${tabButtons.length * 300}px`,
              transform: `translateX(-${currentIndex * 300}px)`
            }"
          >
            <!-- 1번 팝업 -->
            <div class="img-wrap">
              <a href="https://bit.ly/event_2505" target="_blank">
                <img class="img" src="../../assets/popup/concierge/20250613/event1.png" alt="상세 내용 하단 참고"/>
              </a>
              <div class="sr-only">
                <h2>최대 13만원 페이백</h2>
                <p>1형당뇨환우대상 & CGM 구매시</p>
                <ul>
                  <li>
                    <dl>
                      <dt>EVENT 01 : CGM 구매시</dt>
                      <dd>10만원 상당 상품권 증정</dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>EVENT 02 : 후기 작성시</dt>
                      <dd>3만원 상당 상품권 증정</dd>
                    </dl>
                  </li>
                </ul>
                <p>1형당뇨환우대상 CGM 구매시 최대 13만원 페이백 이벤트</p>
                <span>솔닥컨시어지</span>
              </div>
            </div>

            <!-- 2번 팝업 -->
            <div class="img-wrap">
              <a href="https://bit.ly/solm-popup" target="_blank">
                <img class="img" src="../../assets/popup/concierge/20250717/event2.png" alt="상세 내용 하단 참고"/>
              </a>
              <div class="sr-only">
                <h2>Sol-M 33G 펜니들 체험키트 무료증정</h2>
                <p>펜니들을 구매하시는 모든 분에게 sol-M 펜니들 체험키트를 드려요</p>
                <span>솔닥컨시어지</span>
              </div>
            </div>

            <!-- 3번 팝업 -->
            <div class="img-wrap">
              <a href="https://bit.ly/soldoc_document" target="_blank">
                <img class="img" src="../../assets/popup/concierge/20250613/notice2.png" alt="상세 내용 하단 참고"/>
              </a>
              <div class="sr-only">
                <h2>1형 당뇨인 가장 많이 놓치는 세액공제</h2>
                <p>세법상 장애인 증명서 발급받고 세액공제 혜택 챙겨가세요!</p>
                <ul>
                  <li>
                    <dl>
                      <dt>장애인 증명서 발급 안내</dt>
                      <dd>세액공제 200만원 추가</dd>
                      <dd>의료비 세액공제 무제한</dd>
                      <dd>병원 방문 없이 간편발급</dd>
                    </dl>
                  </li>
                </ul>
                <span>솔닥컨시어지</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- 단일팝업 (1개일 때) -->
      <div class="popup-body" v-else-if="tabButtons.length === 1">
        <div class="img-wrap">
          <a href="https://bit.ly/event_2505" target="_blank">
            <img class="img" src="../../assets/popup/concierge/20250430/20250430_pc_event1.png" alt="상세 내용 하단 참고"/>
          </a>
          <div class="sr-only">
            <h2>최대 13만원 페이백</h2>
            <p>1형당뇨환우대상 & CGM 구매시</p>
            <ul>
              <li>
                <dl>
                  <dt>EVENT 01 : CGM 구매시</dt>
                  <dd>10만원 상당 상품권 증정</dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>EVENT 02 : 후기 작성시</dt>
                  <dd>3만원 상당 상품권 증정</dd>
                </dl>
              </li>
            </ul>
            <p>1형당뇨환우대상 CGM 구매시 최대 13만원 페이백 이벤트</p>
            <span>솔닥컨시어지</span>
          </div>
        </div>
      </div>

      <!-- 롤링 버튼 (2개 이상일 때만 표시) -->
      <div class="btn-area" v-if="tabButtons.length > 1">
        <div class="btn-wrap" v-for="(button, index) in tabButtons" :key="index">
          <button
            type="button"
            :class="['btn-tab', currentIndex === index ? 'selected' : '']"
            @click="selectTab(index)"
          >
            <span>{{ button.category }}</span>
            <p>{{ button.title }}</p>
          </button>
        </div>
      </div>

      <!-- 오늘 하루 보지 않기 -->
      <div class="bottom">
				<span class="checkbox-wrapper">
					<input id="today" type="checkbox" v-model="doNotShowToday">
					<label for="today" class="checkbox-text">오늘 하루 보지 않기</label>
				</span>
        <button type="button" :class="['button', pageButtonClass]" @click="close"><i class="ico-close"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import cookies from "@/utilities/cookie.js";

export default {
  name: "mainpopup",
  data() {
    return {
      view: false,
      doNotShowToday: false,
      currentIndex: 0,
      autoPlayInterval: null,
      isHovered: false,
      // 시작: 2025년 4월 30일 오전 00시01분00초
      startDateTime: new Date('2025-04-30T00:01:00'),
      // 종료: 2026년 5월 31일 오후 11시59분59초
      endDateTime: new Date('2026-05-31T23:59:59'),
      // 탭 버튼 정보만 관리 (슬라이드 개수 파악용)
      tabButtons: [
        {
          category: "EVENT",
          title: "페이백 이벤트"
        },
        {
          category: "EVENT",
          title: "무료증정 이벤트"
        },
        {
          category: "NOTICE",
          title: "장애인 증명서"
        },
      ]
    };
  },
  props: {
    pageButtonClass: {
      type: String,
      default: ""
    },
    // 부모 컴포넌트에서 특정 팝업의 노출 일시를 커스터마이징할 수 있는 props
    // ISO 문자열 형식(YYYY-MM-DDTHH:MM:SS) 또는 Date 객체 허용
    customStartDateTime: {
      type: [Date, String],
      default: null // 기본값은 null로 설정하여 data()의 startDateTime이 사용되도록 함
    },
    customEndDateTime: {
      type: [Date, String],
      default: null // 기본값은 null로 설정하여 data()의 endDateTime이 사용되도록 함
    },
    // 외부에서 탭 버튼 정보를 받을 수 있는 prop
    customTabButtons: {
      type: Array,
      default: null
    }
  },
  // computed -> 계산된 속성 추가
  computed: {
    // 실제 사용할 시작 일시: customStartDateTime prop이 있으면 그것을 사용, 없으면 기본 startDateTime 사용
    effectiveStartDateTime() {
      return this.customStartDateTime ? new Date(this.customStartDateTime) : this.startDateTime;
    },

    // 실제 사용할 종료 일시: customEndDateTime prop이 있으면 그것을 사용, 없으면 기본 endDateTime 사용
    effectiveEndDateTime() {
      return this.customEndDateTime ? new Date(this.customEndDateTime) : this.endDateTime;
    },

    // 현재 일시가 설정된 노출 기간 내에 있는지 확인하는 계산된 속성
    isWithinDateTimeRange() {
      const now = new Date(); // 현재 일시 (날짜와 시간 모두 포함)

      // 현재 일시가 시작 일시보다 같거나 크고(>=), 종료 일시보다 같거나 작은지(<=) 확인
      // Date 객체 비교는 타임스탬프 값을 비교하므로 날짜와 시간 모두 정확하게 비교됨
      return now >= this.effectiveStartDateTime && now <= this.effectiveEndDateTime;
    },

    // 슬라이드 개수 (탭 버튼 개수로 파악)
    slideCount() {
      return this.tabButtons.length;
    },

    // 자동재생 간격 계산 (슬라이드가 많을수록 조금 더 길게)
    autoPlayDelay() {
      return Math.max(5000, this.slideCount * 1000);
    }
  },

  watch: {
    // 외부에서 탭 버튼이 변경되면 업데이트
    customTabButtons: {
      handler(newButtons) {
        if (newButtons && Array.isArray(newButtons) && newButtons.length > 0) {
          this.tabButtons = newButtons;
          this.currentIndex = 0; // 인덱스 초기화
          this.restartAutoPlay();
        }
      },
      immediate: true
    }
  },

  mounted() {
    // 쿠키만 확인하던 로직 주석 처리 - 2025-03-31:진형주
    // this.view = cookies.getCookie("today") !== "false";
    // this.startAutoPlay();

    // 두 가지 조건을 모두 확인
    // 1. 현재 일시가 설정된 노출 기간 내에 있는지 확인 (시간까지 포함)
    // 2. 사용자가 '오늘 하루 보지 않기'를 체크하지 않았는지 확인 (기존 로직)
    this.view = this.isWithinDateTimeRange && cookies.getCookie("today") !== "false";

    // 팝업이 표시되고 슬라이드가 2개 이상일 때만 자동 재생 시작
    if (this.view && this.slideCount > 1) {
      this.startAutoPlay();
    }
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    selectTab(index) {
      this.currentIndex = index;
      // 탭 클릭시 자동 재생 초기화
      this.restartAutoPlay();
    },
    startAutoPlay() {
      if (!this.autoPlayInterval && !this.isHovered && this.slideCount > 1) {
        this.autoPlayInterval = setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.slideCount;
        }, this.autoPlayDelay);
      }
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
    restartAutoPlay() {
      this.stopAutoPlay();
      if (!this.isHovered && this.slideCount > 1) {
        this.startAutoPlay();
      }
    },
    pauseAutoPlay() {
      this.isHovered = true;
      this.stopAutoPlay();
    },
    resumeAutoPlay() {
      this.isHovered = false;
      if (this.slideCount > 1) {
        this.startAutoPlay();
      }
    },
    close() {
      if (this.doNotShowToday) {
        cookies.setCookie("today", false);
      }
      this.view = false;
      this.stopAutoPlay();
    },
    goSoldocGuide() {
      window.open(
        "https://www.mohw.go.kr/react/al/sal0101vw.jsp?PAR_MENU_ID=04&MENU_ID=040101&page=1&CONT_SEQ=376488",
        "_blank"
      );
    }
  }
};
</script>


<style scoped>
p {
  margin-bottom: 0;
}
.wrapper {
  position: relative;
  position: fixed;
  top: 200px;
  left: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* width: 366px; */
  width: 300px;
  z-index: 999;
}
.popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  /* height: 418px; */
  /* padding: 34px 20px; */
  background: #f8f9ff;
}
.img {
  width: 100%;
}
.ico-close {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-top: 4px;
  background: url(../../assets/popup/ico_close_white.png) no-repeat center/cover;
}

.popup-body .img-wrap {
  height: 436px;
  overflow: hidden;
}
.popup-body .img-wrap img {
  width: 100%;
  object-fit: cover;
}

.popup-body .logo {
  width: 53px;
  text-align: center;
}
.popup-body .title {
  margin: 19px 0 15px;
  font-family: "Pretendard";
  font-size: 33px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
}
.popup-body .title strong {
  display: block;
  font-weight: 600;
  color: #1f70ff;
}
.popup-body .date {
  font-size: 19px;
  font-weight: 600;
  text-align: center;
  color: #1a1a1a;
}
.popup-body .list {
  width: 100%;
  margin: 24px 0 35px;
  padding: 0;
  font-family: "Pretendard";
  font-size: 17px;
  font-weight: 400;
  line-height: 26px;
  color: #1a1a1a;
  list-style-type: none;
}
.popup-body .list-box li {
  position: relative;
  width: 100%;
  height: 79px;
  padding: 13px 30px 14px 48px;
  border-radius: 8px;
  background: #e6edff;
}
.popup-body .list-box li strong {
  font-weight: 600;
}
.popup-body .list-box li + li {
  margin-top: 15px;
}
.popup-body .list-box li:before {
  position: absolute;
  top: 17px;
  left: 17px;
  width: 20px;
  height: 20px;
  background: url(../../assets/popup/ico_bullet_blue.png);
  content: "";
}
.popup-body .list-box .bg-red {
  background: #f6dfd9;
}
.popup-body .list-box .bg-red:before {
  background: url(../../assets/popup/ico_bullet_red.png);
}
.wrapper .btn-area {
  width: 100%;
}
.wrapper .btn-area .btn-text {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 66px;
  background: #1a1a1a;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #fff;
}
.wrapper .btn-text strong {
  display: inline;
  padding-left: 5px;
  font-weight: 700;
}
.wrapper .btn-text:hover {
  text-decoration: none;
}

.wrapper .bottom {
  height: 32px;
  width: 100%;
  background: #1a1a1a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 11px 0px 11px;
}

.btn-wrapper {
  position: absolute;
  left: 50%;
  bottom: 96px;
  transform: translateX(-50%);
  display: block;
  width: 100%;
  text-align: center;
}

.text-btn:after {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  /* background-color: #00316D; */
}
.checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
}
.checkbox-wrapper input[type="checkbox"] {
  display: none;
}
.checkbox-wrapper input[type="checkbox"] + label {
  cursor: pointer;
}
.checkbox-wrapper input[type="checkbox"] + label:before {
  content: '';
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(../../assets/popup/ico_uncheck_black.png) no-repeat center/cover;
}
.checkbox-wrapper input[type="checkbox"]:checked + label:before {
  background-image: url(../../assets/popup/ico_check_black.png);
}
.checkbox-text {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: -0.02em;
  margin-bottom: 0;
  gap: 4px;
}


.btn-area {
  background-color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
}
.btn-wrap {
  padding:0;
  margin:0;
  flex: 1; /* 균등하게 분배 */
  text-align: center;
}
.btn-wrap:first-child button {
  border: 1px solid #ccc;
}
.btn-wrap button {
  margin:0;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px 1px 1px 0;
}
.btn-wrap button:focus {
  box-shadow: none;
}

.btn-tab {
  display:flex;
  flex-direction: column;
  gap: 6px;
  background-color: #f3f3f3;
  border-radius: 0;
  width: 100%;
  padding: 10px 0;
  justify-items: center;
  justify-content: center;
}
.btn-tab span {
  color: #777;
  font-size: 10px;
  line-height: 10px;
  font-weight: 600;
  letter-spacing: -0.02em;
}
.btn-tab p {
  color: #777;
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
}
.btn-tab.selected {
  background-color: #fff;
}
.btn-tab.selected span{
  color: #008def;
}
.btn-tab.selected p{
  color: #333;
}

/* slide Popup style */
.slide-container {
  position: relative;
  width: 300px;
  overflow: hidden;
}

.slide-item {
  position: relative;
  display: flex;
  transition: transform 0.5s ease;
}

.slide-item .img-wrap {
  flex-shrink: 0;
  width: 300px;
}

/* fade Popup style */
.fade-container {
  position: relative;
  width: 100%;
  height:436px;
}

.fade-container .img-wrap {
  position:absolute;
  left:0;
  top:0;
}

.fade-in {
  transition: opacity 0.5s ease;
  opacity: 1;
}

.fade-out {
  transition: opacity 0.5s ease;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciPopup.vue